import { Chip } from '@mui/material';

import { useT } from '../i18n/LanguageContext';

type Status = 'ACTIVE' | 'ARCHIVED' | 'DISABLED';

/** Active, archived or disabled — a record's state, coloured from the theme. */
export const StatusChip = ({ status }: { status: Status }) => {
  const t = useT();

  return (
    <Chip
      size="small"
      variant="outlined"
      color={status === 'ACTIVE' ? 'success' : 'default'}
      label={t(`status.${status}` as const)}
    />
  );
};
